module.exports = __webpack_public_path__ + "static/media/war_games.11184e51.webp";